import classNames from "classnames";
import React from "react";
import { Spinner } from "react-bootstrap";
import styles from "./button.module.scss";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isLoading?: boolean;
  isDisabled?: boolean;
  variant?: "success" | "info" | "info_outline" | "secondary";
  isRound?: boolean;
  size?: "lg" | "md" | "sm";
}
export const Button: React.FC<ButtonProps> = ({
  className,
  onClick,
  children,
  isDisabled,
  isRound,
  isLoading,
  variant = "info",
  size,
  type,
}) => {
  const buttonClass = classNames(className, [
    styles.button,
    variant === "info" && styles.info,
    variant === "info_outline" && styles.info_outline,
    variant === "success" && styles.success,
    variant === "secondary" && styles.secondary,
    isRound && styles.round,
    size === "md" && styles.size_md,
    size === "sm" && styles.size_sm,
    size === "lg" && styles.size_lg,
    isDisabled && styles.disabled,
    isLoading && styles.loading,
  ]);
  return (
    <button
      className={buttonClass}
      onClick={onClick}
      disabled={isLoading}
      type={type}
    >
      {isLoading ? <Spinner size="sm" /> : children}
    </button>
  );
};
